<template>
  <div class="container mx-auto p-5 h-full">
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      <span class="float-left mr-2">COVERAGE DETAILS</span>
        <button  @click="editDetails(true)" type="button" class="mb-2 inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <i class="fa fa-pencil-square-o mr-1 w-4" aria-hidden="true"></i>
        Edit Details
      </button>
    </h3>
    <hr />
    <div class="no-wrap md:-mx-2 mt-4">
      <!-- Left Side -->
      <div class="w-full md:mx-2 flex mb-4">
        <div
          class="bg-white w-full xl:w-10/12 p-3 shadow-sm rounded-sm border-2"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-user-o"></i>
            </span>
            <span class="tracking-wide">Attorney Type :</span>
            <p class="font-normal">{{ profile_data.attorney_type }}</p>
          </div>
        </div>
      </div>
      <!-- Right Side -->
      <div class="w-full sm:mx-2 mx-0">
         <div
          class="bg-white w-full xl:w-10/12 p-3 shadow-md rounded-sm border-2"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-user"></i>
            </span>
            <span class="tracking-wide">Coverages</span>
          </div>
          <div class="text-gray-700 overflow-x-auto">
            <table class="divide-y divide-gray-200 w-full">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Plan Class
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Coverage
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Sub Coverage
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Remote Consult
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Remote Service
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(item, i) in profile_data?.coverages" :key="i">
                  <td class="px-4 py-2">
                    {{ item.planclass }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.coverage_id }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.sub_coverage }}
                  </td>
                  <td class="px-4 py-2">
                    <span v-if="item.remote_consult == 1">Provided</span>
                    <span  v-if="item.remote_consult == 0"> Not Provided</span>
                  </td>
                  <td class="px-4 py-2">
                    <span v-if="item.remote_service == 1">Provided</span>
                    <span  v-if="item.remote_service == 0"> Not Provided</span>
                  </td>
                  <td class="px-4 py-2">
                    <span
                      v-if="item.deleted == '1' || item.deleted == 1"
                      class="bg-red-200 py-1 px-2 rounded-full text-red-800 text-xs font-semibold"
                      >Deleted</span
                    >
                    <span
                      v-if="item.deleted == '0' || item.deleted == 0"
                      class="bg-green-200 py-1 px-2 rounded-full text-green-800 text-xs font-semibold"
                      >Active</span
                    >
                  </td>
                </tr>
                <tr v-if="profile_data?.coverages?.length <= 0">
                  <td colspan="4" class="text-center p-3">
                    No Records Found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="bg-white w-full xl:w-10/12 p-3 mt-5 shadow-md rounded-sm border-2"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-address-book-o"></i>
            </span>
            <span class="tracking-wide">Practice Area</span>
          </div>
          <div class="text-gray-700 mt-2 overflow-x-auto">
            <table class="divide-y divide-gray-200 w-full">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Plan Class
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    County
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    State Code
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Cdl Rate
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(item, i) in profile_data?.practice_states" :key="i">
                  <td class="px-4 py-2">
                    {{ item.plan_class }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.county }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.state_code }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.cdl_rate }}
                  </td>
                  <td class="px-4 py-2">
                    <span
                      v-if="item.deleted == '1' || item.deleted == 1"
                      class="bg-red-200 py-1 px-2 rounded-full text-red-800 text-xs font-semibold"
                      >Deleted</span
                    >
                    <span
                      v-if="item.deleted == '0' || item.deleted == 0"
                      class="bg-green-200 py-1 px-2 rounded-full text-green-800 text-xs font-semibold"
                      >Active</span
                    >
                  </td>
                </tr>
                <tr v-if="profile_data?.practice_states?.length <= 0">
                  <td colspan="4" class="text-center p-3">
                    No Records Found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="my-4"></div>
      </div>
    </div>
    <div id="coverage_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        class="z-40 left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-5/6 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-2 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1">Edit Details</p>
              <i
                class="fa fa-close w-6 h-6 cursor-pointer"
                @click="editDetails(false)"
              ></i>
            </div>
            <div class="flex flex-col">
              <app-coverages class="editprofile-popup-scroll" ref="child_comp_2" :forms="form"></app-coverages>
              <button
                type="button"
                @click="updateAttorney()"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <i
                  class="fa fa-pencil-square-o mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppCoverages from "./AppCoverages.vue"; // importing resuable input field
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery";
export default {
  name: "PracticeDetails",
  props: ["forms"],
  data: function() {
    // declaring static variable for this component
    return {
      form: this.forms,
    };
  },
  // use to import central level variables from store
  computed: mapState(["profile_data"]),
  //importing resuable components to use in current component
  components: {
    AppCoverages,
  },
  mounted() {
    setTimeout(() => {
      if (typeof this.profile_data?.attorney_type == "string") {
        this.form.attorney_type = this.profile_data?.attorney_type?.split(",");
      }
    }, 1500);
  },
  methods: {
    updateAttorney: function() {
      this.$refs["child_comp_2"].submitApplication();
      if (
        this.$refs["child_comp_2"].v$.form.$pending ||
        this.$refs["child_comp_2"].v$.form.$error
      ) {
        this.$toast.error("please fill required fields!");
        return;
      }
      if(this.form.practice_county_list.length>0){
        let check_cdl_rate=true;
        this.form.practice_county_list.forEach(element => {
          if(element.plan_class=='CDL' && (element.cdl_rate==0 || element.cdl_rate=="") && element.deleted==0){
            check_cdl_rate=false;
          }
        });
        if(!check_cdl_rate){
          this.$toast.error("Please add CDL rate for CDL Plan");
          return false;
        }
      }
      this.$store.dispatch("updateAttorneyData", {
        data: this.form,
      });
      console.log(this.form);
    },
    editDetails: function(value) {
      $("#coverage_detail div").animate({ scrollTop: 0 }, 1000);
      if (value) {
        document.getElementById("coverage_detail").classList.remove("hidden");
      } else {
        document.getElementById("coverage_detail").classList.add("hidden");
        this.$store.dispatch("getAttProfileData");
      }
    },
  },
};
</script>
